export const isConfidentialModeAllowed = (value: unknown): boolean =>
  value !== "off";

export const getPostLeaveExternalUrl = (href: string): string => {
  const url = new URL(href);

  if (/\/chat-standalone\/confidential\/?$/.test(url.pathname)) {
    url.pathname = url.pathname.replace(/\/confidential\/?$/, "");
  }

  return url.href;
};

export const getConfidentialTimeLeft = (
  expiresAt: string,
  now = Date.now(),
): string => {
  const milliseconds = Math.max(0, new Date(expiresAt).getTime() - now);
  const totalMinutes = Math.floor(milliseconds / 60_000);

  if (milliseconds <= 0) return "0m";
  if (totalMinutes <= 0) return "<1m";
  if (totalMinutes >= 60) {
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    return `${hours}h ${minutes}m`;
  }
  return `${totalMinutes}m`;
};
